import React, { useState, useEffect } from 'react'
import style from './amountCardActor.module.scss'
import VegaColors from '../../../resources/constants/colors.module.scss'
import { VegaIcon, VegaIconBank, VegaIconFlag } from '../../../components/vega/icon/Icon'
import { VegaHeading } from '../../../components/vega/heading/Heading'
import { getBankLocation } from '../../../utils/formatting/BankLocation'
import { useTranslation } from 'react-i18next'
import { VegaTypo } from '../../vega/typography/Typography'
import { PropTypes } from 'prop-types'
import cx from 'classnames'

/**
 * Column in the AmountCard that show actors datas
 */
const AmountCardActor = ({ actorName, bank, accountNumber, isBeneficiary }) => {
	const { t, i18n } = useTranslation()
	const language = i18n.language

	const [bankLocation, setBanklocation] = useState(t('unknownBankLocation'))

	const bankCity = bank?.location?.city
	const bankCountry = bank?.location?.country

	useEffect(() => {
		getBankLocation(bankCity, bankCountry, language).then(setBanklocation)
	}, [bankCity, bankCountry, language])

	const accountNumberFormatted = accountNumber?.replace(/(.{4})/g, '$1 ').trim()

	return (
		<div
			className={cx([style.actor, isBeneficiary ? style.beneficiary : style.creditor])}
		>
			<VegaHeading
				tag={'h7'}
				label={t(isBeneficiary ? 'headerPaymentBeneficiary' : 'headerPaymentCreditor')}
				className={style.label}
			/>
			<div className={style.entityName}>
				<VegaIcon
					size={20}
					name={actorName && 'office'}
					color={VegaColors.PRIMARY}
					className={style.icon}
				/>
				<div className={style.amountCardLabel}>
					<VegaTypo label={actorName || t('unknownBankName')} title={true} />
				</div>
			</div>
			<div className={cx([style.bankName, !isBeneficiary && style.sender])}>
				<VegaIconBank
					size={20}
					className={style.icon}
					placeholder={bank?.name}
					src={bank?.logo}
				/>
				<div className={style.amountCardLabel}>
					<VegaTypo className={style.name} label={bank?.name} title={true} />
					{isBeneficiary && <VegaTypo
						className={style.accountNumber}
						label={accountNumberFormatted}
						title={true}
					/>}
				</div>
			</div>
			<div className={style.bankLocation}>
				<VegaIconFlag
					size={20}
					country={bankCountry || (bank && '')}
					className={style.icon}
				/>
				<div className={style.amountCardLabel}>
					<VegaTypo label={bankLocation} title={true} />
				</div>
			</div>
		</div>
	)
}

AmountCardActor.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Beneficiary or Creditor datas */
	actorName: PropTypes.string,
	bank: PropTypes.shape({
		name: PropTypes.string,
		location: PropTypes.shape({
			city: PropTypes.string,
			country: PropTypes.string
		})
	}),
	/** Used for styling and label */
	isBeneficiary: PropTypes.bool
}

export { AmountCardActor }
